<template>
      <div class="grid grid-rows-2 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-8 md:px-0" >

        <!-- PHOTO BOX -->
        <transition name="zoom">
        <div :class="{
          'bg-gradient-to-r from-green-600 to-green-900 dark:from-green-400 dark:to-green-500 px-1 py-1 shadow-lg rounded-3xl transition-transform duration-500 ease-in-out': true,
          'transform -rotate-6 hover:rotate-4': mounted.box1Step2,
          }" v-show="mounted.box1">
          <div :class="{
            'bg-gradient-to-r shadow from-blueGray-700 to-blueGray-900 dark:from-blueGray-400 dark:to-blueGray-600 rounded-3xl px-1 py-1 transition-transform duration-500 ease-in-out': true,
            'transform rotate-3': mounted.box1Step2,
            }">
            <div :class="{
              'shadow-sm bg-gray-100 dark:bg-gray-200 rounded-3xl p-3 transition-transform duration-500 ease-in-out': true,
              'transform rotate-3': mounted.box1Step2,
            }">
              <img :src="data.pictures.photo" :alt="data.info.name" class="rounded-3xl max-h-80 mx-auto">
            </div>
          </div>
        </div>
        </transition>
        <!-- /PHOTO BOX -->

        <!-- INFO BOX -->
        <div class="lg:col-span-2 sm:col-span-1 text-gray-300 relative bg-black md:bg-opacity-0 bg-opacity-70">
          <transition name="fadeDown">
            <span class="text-md sm:text-lg md:text-xl " v-if="mounted.degree">{{data.info.degree}}</span>
          </transition>
          <transition name="fadeUp">
            <h1 class="text-3xl sm:text-3xl md:text-4xl lg:text-6xl" v-if="mounted.name">{{data.info.name}}</h1>
          </transition>
          <transition name="zoom">
            <h2 class="text-lg sm:text-xl md:text-2xl lg:text-3xl" v-if="mounted.profession">{{data.info.profession}}</h2>
          </transition>
          <!-- <br>
          <transition name="fadeRight">
            <p class="text-md sm:text-lg md:text-xl" v-if="mounted.direction">{{data.info.direction}}</p>
          </transition> -->
          <br>
          <transition name="zoom">
            <button v-if="mounted.button" 
            class="mx-1 py-2 px-4
              text-white
              bg-gradient-to-b
              from-green-700 to-green-800
              hover:from-green-600 hover:to-green-700
              dark:text-gray-100
              dark:from-green-500 dark:to-green-600
              dark:hover:from-green-400 dark:hover:to-green-500
              font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-75"
            @click="$router.push('/projects')">
              {{ buttons.myProjects }}
            </button>
          </transition>
          <br>
          <transition name="zoom">
            <a v-if="mounted.button" 
            href="#navbar"
            class="mx-1 py-2 px-4
            bg-gradient-to-b
            from-blueGray-700 to-blueGray-800
            hover:from-blueGray-600 hover:to-blueGray-700
            dark:from-blueGray-500 dark:to-blueGray-600
            dark:hover:from-blueGray-400 dark:hover:to-blueGray-500
            text-white 
            dark:text-blueGray-300 
            font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-75"
            @click="$store.commit('showContact')">
              {{ buttons.contactMe }}
            </a>
          </transition>
        </div>
        <!-- /INFO BOX -->

        <!-- APT BOX -->
        <transition name="slideUp">
        <div v-if="mounted.aptitude" >
          <ListComponent 
          :title="'Aptitudes'"
          :list="[
            'Programación Back-end & Front-end',
            'Análisis de Datos',
            'Optimización de motores de búsquedas (SEO)'
          ]"
          :backgroundColorClass="'from-gray-200 to-gray-900 dark:from-gray-600 dark:to-gray-900'"
          :rotateClass="mounted.aptitudeStep2 ? '-rotate-6' : ''" />
        </div>
        </transition>
        <!-- /APT BOX -->

        <transition name="slideUp">
        <div v-if="mounted.knowledge" >
          <ListComponent 
          :title="'Conocimientos'"
          :list="[
            'Javascript | VueJS | NuxtJS',
            'Python | Django | PostgreSQL',
            'CSS | SCSS | SASS'
          ]"
          :backgroundColorClass="'from-green-600 to-green-900 dark:from-green-400 dark:to-green-500 '"
          :rotateClass="mounted.knowledgeStep2 ?'rotate-90':''" />
        </div>
        </transition>

        <transition name="slideUp">
        <div v-if="mounted.compt" >
          <ListComponent 
          :title="'Competencias'"
          :list="[
            'Habilidad de pensamiento lógico',
            'Creatividad',
            'Resolución de Problemas'
          ]"
          :backgroundColorClass="'from-gray-600 to-gray-200 dark:from-gray-900 dark:to-gray-600'"
          :rotateClass="mounted.comptStep2 ? 'rotate-6':''" />
        </div>
        </transition>


    </div>
</template>

<script>
import ListComponent from '@/components/List.vue'
export default {
    name:'IndexPage',
    components: {
        ListComponent
    },
    data:()=>({
        mounted: {
            aptitude:false,
            aptitudeStep2: false,
            knowledge:false,
            knowledgeStep2: false,
            compt:false,
            comptStep2: false,
            button:false,
            photo:false,
            name:false,
            degree:false,
            profession:false,
            box1:false,
            box1Step2: false,
            box2:false,
            direction:false,
        },
    }),
    computed: {
      data() {
        return this.$store.state.index
      },
      buttons() {
          return this.$store.getters.GetButtons
      }
    },
    async mounted() {
        const delay = ms => new Promise(res => setTimeout(res, ms));
        // await delay(1000)
        this.mounted.box1 = true
        await delay(250)
        this.mounted.box1Step2 = true
        await delay(500)
        this.mounted.name = true
        await delay(650)
        this.mounted.degree = true
        await delay(500)
        this.mounted.profession = true
        await delay(500)
        this.mounted.direction = true
        await delay(250)
        this.mounted.button = true
        await delay(500)
        this.mounted.aptitude = true
        await delay(250)
        this.mounted.aptitudeStep2 = true
        await delay(250)
        this.mounted.knowledge = true
        await delay(250)
        this.mounted.knowledgeStep2 = true
        await delay(250)
        this.mounted.compt = true 
        await delay(250)
        this.mounted.comptStep2 = true       
    }
}
</script>

<style>

</style>